import { useEffect, useState } from 'react';
import { IGetScoreDetails } from '../report-models/report.interface';

export default function useInitiateProgressBar(data: IGetScoreDetails) {
  const [progressValue, setProgressValue] = useState<number>(0);

  useEffect(() => {
    const initProgress = () => {
      let progressStartValue = 0;
      const progressEndValue = Math.min(
        Math.max(data?.percentScore || 0, 0),
        100
      ); // Clamp to 0-100
      const speed = 10;

      const progress = setInterval(() => {
        progressStartValue++;
        setProgressValue(progressStartValue);

        if (progressStartValue >= progressEndValue) {
          clearInterval(progress);
        }
      }, speed);

      return () => clearInterval(progress); // Cleanup on unmount or change
    };

    if (data?.percentScore) {
      initProgress();
    }

    return () => setProgressValue(0); // Reset progress when unmounting
  }, [data?.percentScore]);

  return {
    progressValue,
  };
}
